<script context="module">
  export type IConstruction = {
    address: string;
    id: number;
    caseNumber: string;
    emails: IConstructionEmail[];
  };

  export type IConstructionEmail = {
    id: number;
    email: string;
  };

  export interface IConstructionSelect extends IConstruction {
    label: string;
  };
</script>

<script>
  import { t } from "../../../../core";
  import AsideBlock from "../../../blocks/AsideBlock.svelte";
  import { onMount } from "svelte";
  import axios, { AxiosResponse, AxiosError } from "axios";
  import Select from "svelte-select";
  import FormErrors from "../../../elements/FormErrors.svelte";

  let constructions: IConstructionSelect[] = [];
  let selectedConstruction: IConstructionSelect;
  let customerEmail: IConstructionEmail | null = null;
  let errorMessage: string = "";

  onMount(() => {
    axios
      .get("/api/SuperCustomer/getConstructions")
      .then((res: AxiosResponse<IConstruction[]>) => {
        constructions = res.data.map((construction) => ({
          ...construction,
          label: `${construction.caseNumber} - ${construction.address}`,
        }));
      });
  });

  function handleSelect(event: CustomEvent<IConstructionSelect>) {
    selectedConstruction = event.detail
    customerEmail = null;
  }

  function startImpersonation() {
    errorMessage = "";
    
    axios
      .post("/api/SuperCustomer/startImpersonation", {
        customerEmailId: customerEmail!.id,
        customerId: selectedConstruction.id
      })
      .then(() => location.reload())
      .catch((err: AxiosError) => (errorMessage = err?.response?.data))
  }
</script>

<AsideBlock title={t("Impersonation.Block.Title")}>
  <div class="impersonation">
    {#if constructions?.length > 0}
      <div class="impersonation__select">
        <Select
          placeholder={t("Impersonation.CaseNumber.Placeholder")}
          items={constructions}
          isClearable={false}
          optionIdentifier="id"
          on:select={handleSelect}
        />
      </div>

      {#key selectedConstruction}
        {#if selectedConstruction?.emails?.length > 0}
          <div class="impersonation__select">
            <Select
              placeholder={t("Impersonation.Email.Placeholder")}
              isClearable={false}
              items={selectedConstruction.emails}
              labelIdentifier="email"
              optionIdentifier="id"
              bind:value={customerEmail}
            />
          </div>
        {/if}
      {/key}

      {#if errorMessage}
        <FormErrors {errorMessage} />
      {/if}

      <button
        class="btn"
        on:click={startImpersonation}
        disabled={!customerEmail}
      >
        {t("Impersonation.Action.Start")}
      </button>
    {/if}
  </div>
</AsideBlock>

<style lang="scss">
  .impersonation {
    &__select {
      margin-bottom: 20px;
    }
  }
</style>
